"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventSchema = void 0;
const zod_1 = __importDefault(require("zod"));
exports.EventSchema = zod_1.default.discriminatedUnion('type', [
    zod_1.default.object({
        type: zod_1.default.literal('response.created'),
        response: zod_1.default.object({
            id: zod_1.default.string(),
        }),
    }),
    zod_1.default.object({
        type: zod_1.default.literal('response.done'),
        response: zod_1.default.object({
            id: zod_1.default.string(),
            conversation_id: zod_1.default.string().nullable(),
            output: zod_1.default.array(zod_1.default.discriminatedUnion('type', [
                zod_1.default.object({
                    type: zod_1.default.literal('function_call'),
                    arguments: zod_1.default.string(),
                    name: zod_1.default.string(),
                    call_id: zod_1.default.string(),
                }),
                zod_1.default.object({
                    type: zod_1.default.literal('function_call_output'),
                    call_id: zod_1.default.string(),
                    output: zod_1.default.string(),
                }),
                zod_1.default.object({
                    type: zod_1.default.literal('message'),
                    content: zod_1.default.array(zod_1.default.discriminatedUnion('type', [
                        zod_1.default.object({
                            type: zod_1.default.enum(['audio']),
                            transcript: zod_1.default.string(),
                        }),
                        zod_1.default.object({
                            type: zod_1.default.literal('text'),
                            text: zod_1.default.string(),
                        }),
                    ])),
                }),
            ])),
        }),
    }),
    zod_1.default.object({
        event_id: zod_1.default.string(),
        type: zod_1.default.literal('conversation.item.created'),
        item: zod_1.default.object({
            id: zod_1.default.string(),
            role: zod_1.default.enum(['user', 'system']),
            type: zod_1.default.enum(['message']),
            content: zod_1.default.array(zod_1.default.discriminatedUnion('type', [
                zod_1.default.object({
                    type: zod_1.default.literal('input_text'),
                    text: zod_1.default.string(),
                }),
                zod_1.default.object({
                    type: zod_1.default.literal('input_audio'),
                    transcript: zod_1.default.string().nullable(),
                }),
                zod_1.default.object({
                    type: zod_1.default.literal('audio'),
                    transcript: zod_1.default.string().nullable(),
                }),
            ])),
        }),
    }),
    zod_1.default.object({
        event_id: zod_1.default.string(),
        item_id: zod_1.default.string(),
        type: zod_1.default.literal('conversation.item.input_audio_transcription.completed'),
        transcript: zod_1.default.string(),
        content_index: zod_1.default.number(),
    }),
    zod_1.default.object({
        event_id: zod_1.default.string(),
        type: zod_1.default.literal('input_audio_buffer.append'),
        item_id: zod_1.default.string(),
        audio: zod_1.default.string(),
    }),
    zod_1.default.object({
        event_id: zod_1.default.string(),
        type: zod_1.default.literal('input_audio_buffer.speech_started'),
        item_id: zod_1.default.string(),
        audio_start_ms: zod_1.default.number(),
    }),
    zod_1.default.object({
        event_id: zod_1.default.string(),
        type: zod_1.default.literal('input_audio_buffer.speech_stopped'),
        item_id: zod_1.default.string(),
        audio_end_ms: zod_1.default.number(),
    }),
    zod_1.default.object({
        event_id: zod_1.default.string(),
        type: zod_1.default.literal('session.updated'),
        session: zod_1.default.object({
            model: zod_1.default.string(),
            modalities: zod_1.default.array(zod_1.default.enum(['text', 'audio'])),
            instructions: zod_1.default.string(),
            tools: zod_1.default.array(zod_1.default.object({
                type: zod_1.default.literal('function'),
                name: zod_1.default.string(),
                description: zod_1.default.string(),
                parameters: zod_1.default.record(zod_1.default.string(), zod_1.default.any()),
            })),
            tool_choice: zod_1.default.union([zod_1.default.enum(['auto', 'none', 'required']), zod_1.default.string()]),
        }),
    }),
    zod_1.default.object({
        event_id: zod_1.default.string(),
        type: zod_1.default.literal('response.function_call_arguments.done'),
        response_id: zod_1.default.string(),
        item_id: zod_1.default.string(),
        output_index: zod_1.default.number(),
        call_id: zod_1.default.string(),
        arguments: zod_1.default.string(),
    }),
    zod_1.default.object({
        event_id: zod_1.default.string(),
        type: zod_1.default.literal('response.output_item.done'),
        response_id: zod_1.default.string(),
        output_index: zod_1.default.number(),
        item: zod_1.default.discriminatedUnion('type', [
            zod_1.default.object({
                id: zod_1.default.string(),
                type: zod_1.default.literal('message'),
                content: zod_1.default.array(zod_1.default.discriminatedUnion('type', [
                    zod_1.default.object({
                        type: zod_1.default.literal('input_text'),
                        text: zod_1.default.string(),
                    }),
                    zod_1.default.object({
                        type: zod_1.default.literal('input_audio'),
                        transcript: zod_1.default.string().nullable(),
                    }),
                    zod_1.default.object({
                        type: zod_1.default.literal('audio'),
                        transcript: zod_1.default.string().nullable(),
                    }),
                    zod_1.default.object({
                        type: zod_1.default.literal('text'),
                        text: zod_1.default.string(),
                    }),
                ])),
            }),
            zod_1.default.object({
                id: zod_1.default.string(),
                type: zod_1.default.literal('function_call'),
                call_id: zod_1.default.string(),
                name: zod_1.default.string(),
                arguments: zod_1.default.string(),
            }),
            zod_1.default.object({
                id: zod_1.default.string(),
                type: zod_1.default.literal('function_call_output'),
                call_id: zod_1.default.string(),
                name: zod_1.default.string(),
                arguments: zod_1.default.string(),
                output: zod_1.default.string(),
            }),
        ]),
    }),
]);
//# sourceMappingURL=clientSchema.js.map